import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { CheckCircle2, AlertTriangle, Info, X } from 'lucide-react';
import '../styles/Toast.css';

const ToastContext = createContext(null);

const ICONOS = { exito: CheckCircle2, error: AlertTriangle, info: Info };

export function ToastProvider({ children }) {
  const [avisos, setAvisos] = useState([]);

  const cerrar = useCallback((id) => {
    setAvisos((prev) => prev.filter((a) => a.id !== id));
  }, []);

  const mostrar = useCallback(
    (mensaje, tipo = 'info', duracion = 4000) => {
      const id = Date.now() + Math.random();
      setAvisos((prev) => [...prev, { id, mensaje, tipo }]);
      if (duracion > 0) setTimeout(() => cerrar(id), duracion);
    },
    [cerrar]
  );

  const api = useMemo(
    () => ({
      exito: (m) => mostrar(m, 'exito'),
      error: (m) => mostrar(m, 'error', 6000),
      info: (m) => mostrar(m, 'info')
    }),
    [mostrar]
  );

  return (
    <ToastContext.Provider value={api}>
      {children}
      <div className="toast-stack" role="status" aria-live="polite">
        {avisos.map(({ id, mensaje, tipo }) => {
          const Icono = ICONOS[tipo];
          return (
            <div key={id} className={`toast is-${tipo}`}>
              <Icono size={17} strokeWidth={1.75} className="toast-icon" />
              <span className="toast-text">{mensaje}</span>
              <button className="toast-close" onClick={() => cerrar(id)} aria-label="Cerrar aviso">
                <X size={15} strokeWidth={2} />
              </button>
            </div>
          );
        })}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast debe usarse dentro de ToastProvider');
  return ctx;
}
